import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { InvoiceData } from 'src/app/intefaces/invoice-data.interface';


@Component({
  selector: 'invoice-data',
  templateUrl: './invoice-data.component.html',
  styleUrls: ['./invoice-data.component.scss']
})
export class InvoiceDataComponent implements OnInit {

  isDataReady = false;
  invoiceDetailsForm: FormGroup;
  invoiceDetailsFormPreviousValues: any;
  isEditing = false;
  showLoader = false;
  invoiceData: InvoiceData;

  constructor(
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private alertService: HttpAlertService,
    private translate: TranslateService) {
    this.invoiceDetailsForm = this.formBuilder.group({
      company_name: ['', Validators.required],
      company_address: ['', Validators.required],
      company_contact: ['', Validators.required],
      company_web: ['', Validators.required],
      company_nip: ['', Validators.required],
      company_bank: ['', Validators.required],
      company_account: ['', Validators.required],
      company_place: ['', Validators.required],
      seller_name: ['', Validators.required],
      seller_address_1: ['', Validators.required],
      seller_address_2: ['', Validators.required],
      invoice_issued_by: ['', Validators.required],
      enclosure: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.isDataReady = true;
    this.adminService.getInvoiceData().subscribe((response: any) => {
      this.populateForm(response.data.invoice_data);
    });
  }

  private populateForm(invoiceData: InvoiceData): void {
    this.invoiceDetailsForm.patchValue(invoiceData);
    setTimeout(() => {
      this.disabledForm();
    }, 100);
    this.isDataReady = true;
  }

  private disabledForm(): void {
    this.invoiceDetailsForm.disable();
    this.isEditing = false;
  }

  private enableForm(): void {
    this.invoiceDetailsForm.enable();
    this.isEditing = true;
  }

  public startEditing() {
    this.invoiceDetailsFormPreviousValues = this.invoiceDetailsForm.value;
    this.enableForm();
  }

  public cancelEditing(): void {
    this.invoiceDetailsForm.setValue(this.invoiceDetailsFormPreviousValues);
    this.disabledForm();
  }

  public onSubmit(): void {
    this.disabledForm();
    this.translate.get(['data_updated_success', 'data_updated_error']).subscribe(t => {
      console.log(this.invoiceDetailsForm.value);
      this.adminService.updateInvoiceData(this.invoiceDetailsForm.value).subscribe(
        result => { this.alertService.success(t.data_updated_success); },
        error => { this.alertService.error(t.data_updated_error); }
      );
    });
  }

  public downloadExampleInvoice(): void {
    this.showLoader = true;
    this.adminService.downloadTestInvoice().subscribe(
      blob => {
        this.showLoader = false;
        saveAs(blob, 'test_invoice.pdf');
      },
      error => {
        console.error(error);
      }
    );
  }

}

